'use client';

import { type Component, type ComponentProps } from '../../types/component';
import { tv } from '../../utils/tv';

const menuHeaderClasses = { root: 'zds-menu-header-root' } as const;

const menuHeaderStyles = tv({
  base: [menuHeaderClasses.root, 'col-span-3 -mt-1 mb-1 p-4'],
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface MenuHeaderBaseProps {}

type MenuHeaderProps = ComponentProps<MenuHeaderBaseProps, 'div'>;

type MenuHeaderComponent = Component<MenuHeaderBaseProps, 'div'>;

const MenuHeader: MenuHeaderComponent = (props) => {
  const { className, ref, children, ...rest } = props;

  return (
    <div {...rest} ref={ref} className={menuHeaderStyles({ className })}>
      {children}
    </div>
  );
};

MenuHeader.displayName = 'Menu.Header';

export {
  MenuHeader,
  type MenuHeaderProps,
  type MenuHeaderBaseProps,
  menuHeaderClasses,
};
